export default {
  system: {
    method: 'get',
    url: '/client/analysis/system'
  },
  driver: {
    method: 'post',
    url: '/client/analysis/driver'
  },
  quote: {
    method: 'get',
    url: '/client/analysis/quote'
  },
  quoteRequest: {
    method: 'get',
    url: '/client/analysis/quote-request'
  },
  cost: {
    method: 'post',
    url: '/client/analysis/cost'
  },
  finance: {
    method: 'get',
    url: '/client/analysis/finance'
  },
  getDriverTransportStatus: {
    method: 'get',
    url: '/client/dashbroad/driver-transport-status'
  }
}
